/* eslint-disable react/jsx-no-bind */
import React from 'react'
import { arrayOf, shape, string, func, node } from 'prop-types'
import styled from '@emotion/styled'
import { list } from '@groovehq/internal-design-system/lib/styles/elements'
import SelectorButton from './SelectorButton'

import { styles } from './Selector.styles'

export const Item = styled.li`
  button {
    border-color: ${({ active, theme }) =>
      active && theme.color.buttonPrimary.borderHover};
  }
`

const Selector = ({ className, list: listProp, selected, onSelect }) => {
  return (
    <ul css={[list.styles.preflight, styles.base]} className={className}>
      {listProp.map(({ type, title, icon }) => {
        return (
          <Item key={type} active={selected === type}>
            <SelectorButton
              onClick={onSelect}
              type={type}
              title={title}
              icon={icon}
            />
          </Item>
        )
      })}
    </ul>
  )
}

Selector.propTypes = {
  className: string,
  list: arrayOf(
    shape({
      type: string,
      title: string,
      icon: node,
    })
  ),
  onSelect: func,
  selected: string,
}

Selector.defaultProps = {
  className: undefined,
  list: [],
  onSelect() {},
  selected: undefined,
}

export default Selector
